(function () {
  'use strict';

  const WORKER_URL = 'https://claudio-goblow.goblowau.workers.dev';
  const STORAGE_KEY = 'claudio_history';
  const OPEN_KEY = 'claudio_open';
  const LEAD_KEY = 'claudio_lead';

  let lead = null;
  try { lead = JSON.parse(sessionStorage.getItem(LEAD_KEY) || 'null'); } catch (e) { lead = null; }
  function saveLead() {
    try { sessionStorage.setItem(LEAD_KEY, JSON.stringify(lead)); } catch (e) {}
  }

  // Load history from sessionStorage so it survives page navigation
  let history = [];
  try {
    history = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
  } catch (e) {
    history = [];
  }

  function saveHistory() {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(history)); } catch (e) {}
  }

  function getEl(id) { return document.getElementById(id); }

  function addMessage(role, text) {
    const msgs = getEl('claudio-messages');
    const div = document.createElement('div');
    div.className = 'claudio-msg ' + (role === 'user' ? 'user' : 'bot');
    if (role === 'user') {
      div.textContent = text;
    } else {
      // Bot replies: escape everything, then turn bare URLs into real links so the Owner's Guide and product pages are tappable.
      var esc = String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      div.innerHTML = esc.replace(/(https?:\/\/[^\s<]+[^\s<.,;:!?)\]"'])/g, function (u) {
        var label = /\.pdf(\?|$)/i.test(u) ? "Open the Owner's Guide (PDF)" : u.replace(/^https?:\/\//, '');
        return '<a href="' + u + '" target="_blank" rel="noopener" class="claudio-link">' + label + '</a>';
      });
    }
    msgs.appendChild(div);
    msgs.scrollTop = msgs.scrollHeight;
    return div;
  }

  function showTyping() {
    const msgs = getEl('claudio-messages');
    const el = document.createElement('div');
    el.className = 'claudio-typing';
    el.id = 'claudio-typing-indicator';
    el.innerHTML = '<span></span><span></span><span></span>';
    msgs.appendChild(el);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function removeTyping() {
    const el = getEl('claudio-typing-indicator');
    if (el) el.remove();
  }

  // Restore previous messages visually on page load
  function restoreMessages() {
    history.forEach(function (msg) {
      addMessage(msg.role === 'user' ? 'user' : 'bot', msg.content);
    });
  }

  async function sendMessage(text) {
    if (!text.trim()) return;

    history.push({ role: 'user', content: text });
    saveHistory();
    addMessage('user', text);

    const input = getEl('claudio-input');
    const send = getEl('claudio-send');
    input.value = '';
    input.disabled = true;
    send.disabled = true;

    showTyping();

    try {
      const res = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: history, lead: lead && lead.email ? lead : undefined }),
      });

      const data = await res.json();
      const reply = data.reply || 'Something went sideways — try again.';

      removeTyping();
      history.push({ role: 'assistant', content: reply });
      saveHistory();
      addMessage('bot', reply);
    } catch {
      removeTyping();
      addMessage('bot', 'Connection issue. Try again in a sec.');
    } finally {
      input.disabled = false;
      send.disabled = false;
      input.focus();
    }
  }

  function init() {
    const toggle = getEl('claudio-toggle');
    const window_ = getEl('claudio-window');
    const close = getEl('claudio-close');
    const input = getEl('claudio-input');
    const send = getEl('claudio-send');

    if (!toggle) return;

    // Restore previous chat messages
    restoreMessages();

    // Re-open chat if it was open on the previous page
    if (sessionStorage.getItem(OPEN_KEY) === '1') {
      window_.classList.add('open');
    }

    // Proactive nudge — show a teaser bubble after 12s if chat never opened
    const nudgeMessages = [
      "Not sure which finish? I can sort you out. 😈",
      "Five finishes, one keeper. Ask me which. ✨",
      "Looking for a gift? I know exactly what to grab. 👇",
      "Quick question? I'm faster than a Google search.",
    ];
    const nudgeKey = 'claudio_nudged';
    if (!sessionStorage.getItem(nudgeKey) && !sessionStorage.getItem(OPEN_KEY) && history.length === 0) {
      setTimeout(function () {
        if (!window_.classList.contains('open')) {
          sessionStorage.setItem(nudgeKey, '1');
          const nudge = document.createElement('div');
          nudge.id = 'claudio-nudge';
          nudge.style.cssText = 'position:absolute;bottom:68px;right:0;background:#1e1e1e;border:1px solid #2a2a2a;border-radius:12px;padding:10px 14px;font-size:13px;color:#d4d4d4;white-space:nowrap;box-shadow:0 4px 20px rgba(0,0,0,0.4);cursor:pointer;animation:claudio-fade 0.3s ease;max-width:240px;white-space:normal;line-height:1.4;';
          nudge.textContent = nudgeMessages[Math.floor(Math.random() * nudgeMessages.length)];
          nudge.addEventListener('click', function () {
            nudge.remove();
            toggle.click();
          });
          getEl('claudio-bubble').appendChild(nudge);
          // Auto-dismiss after 8 seconds
          setTimeout(function () { if (nudge.parentNode) nudge.remove(); }, 8000);
        }
      }, 12000);
    }

    function showPrechat() {
      if (getEl('claudio-prechat')) return;
      const msgs = getEl('claudio-messages');
      const box = document.createElement('div');
      box.id = 'claudio-prechat';
      box.innerHTML =
        '<div class="claudio-prechat-title">First your name and email, then Claudio is all yours</div>' +
        '<input id="claudio-pc-name" type="text" placeholder="First name" autocomplete="given-name" maxlength="40">' +
        '<input id="claudio-pc-email" type="email" placeholder="Email" autocomplete="email" maxlength="80">' +
        '<div id="claudio-pc-err"></div>' +
        '<button id="claudio-pc-start" type="button">Start chat</button>';
      msgs.appendChild(box);
      getEl('claudio-input-area').style.display = 'none';
      function finish() {
        box.remove();
        getEl('claudio-input-area').style.display = '';
        greetIfNew();
        getEl('claudio-input').focus();
      }
      getEl('claudio-pc-start').addEventListener('click', function () {
        const n = getEl('claudio-pc-name').value.trim();
        const em = getEl('claudio-pc-email').value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) {
          getEl('claudio-pc-err').textContent = 'That email does not look right.';
          return;
        }
        lead = { name: n, email: em };
        saveLead();
        finish();
      });
    }

    function greetIfNew() {
      if (history.length === 0) {
        setTimeout(function () {
          const who = lead && lead.name ? ' ' + lead.name : '';
          const greeting = "Hey" + who + " — I'm Claudio. Ask me anything about GoBlow. 😈";
          history.push({ role: 'assistant', content: greeting });
          saveHistory();
          addMessage('bot', greeting);
        }, 300);
      }
    }

    toggle.addEventListener('click', function () {
      window_.classList.toggle('open');
      if (window_.classList.contains('open')) {
        sessionStorage.setItem(OPEN_KEY, '1');
        if (!lead && history.length === 0) {
          showPrechat();
        } else {
          input.focus();
          greetIfNew();
        }
        const msgs = getEl('claudio-messages');
        msgs.scrollTop = msgs.scrollHeight;
        return;
      } else {
        sessionStorage.removeItem(OPEN_KEY);
      }
      if (false) {
        if (history.length === 0) {
        }
      }
    });

    close.addEventListener('click', function () {
      window_.classList.remove('open');
      sessionStorage.removeItem(OPEN_KEY);
    });

    send.addEventListener('click', function () {
      sendMessage(input.value);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendMessage(input.value);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
